import { useCallback } from 'react'
import { Icon } from 'util/ui'

import useDoUpdateCustomFieldValuesFromForm from '../../../useDoUpdateCustomFieldValuesFromForm'
import ContactHeaderFieldsEditModal from './ContactHeaderFieldsEditModal'

export default function ContactHeaderFieldsEditButton({
  doRecalcMenuPosition,
  doSetMenu,
  firstName,
  lastName,
  menuRef,
  offset,
  openMenu,
  subjectId,
  type,
}) {
  const doOpen = useCallback(() => doSetMenu('edit'), [doSetMenu])
  const doClose = useCallback(() => doSetMenu(null), [doSetMenu])
  const onSave = useDoUpdateCustomFieldValuesFromForm(subjectId)
  return (
    <>
      <div className="action" onClick={doOpen}>
        <Icon name="pencil" size="small" />
      </div>
      {openMenu === 'edit' && (
        <ContactHeaderFieldsEditModal
          doRecalcMenuPosition={doRecalcMenuPosition}
          firstName={firstName}
          lastName={lastName}
          menuRef={menuRef}
          offset={offset}
          onCancel={doClose}
          onSave={onSave}
          type={type}
        />
      )}
    </>
  )
}
